import { diffDaysFromAppToday, getLocalDateIso } from '../config/timezone';

/**
 * Calendar days (Europe/Rome) from today to the day of `endsAt`, never negative.
 * The day the period ends counts as 0 even before the end instant: "today is the
 * last day". Single source for the trial countdown shown by the customer app and
 * the back office.
 */
export function getCalendarDaysUntil(endsAt: string | null | undefined, now?: Date): number | null {
  if (!endsAt) {
    return null;
  }
  const end = new Date(endsAt);
  if (Number.isNaN(end.getTime())) {
    return null;
  }
  const days = diffDaysFromAppToday(getLocalDateIso(end), now);
  return days === null ? null : Math.max(0, days);
}
